const accessMaster = {


    ADD_ITEM_CATEGORY: {
        path: '/add-item-category'
    },

    UPDATE_ITEM_CATEGORY: {
        path: '/edit-item-category'
    },

    ITEM_CATEGORY_LIST: {
        path: '/item-category-list'
    },


    SKILL_MATRIX_LIST: {
        path: '/skill-matrix-list'
    },

    ADD_SKILL_MATRIX: {
        path: '/add-skill-matrix'
    },

    UPDATE_SKILL_MATRIX: {
        path: '/edit-skill-matrix'
    },

    ADD_BRAND: { name: 'Add Brand', path: '/add-brand' },
    UPDATE_BRAND: { name: 'Edit Brand', path: '/edit-brand' },
    BRAND_LIST: { name: 'Brand', path: '/brand-list' },
    DELETE_BRAND: { name: 'Delete Brand', path: '/delete-brand' },

    ADD_CATEGORY: { name: 'Add Category', path: '/add-category' },
    UPDATE_CATEGORY: { name: 'Edit Category', path: '/edit-category' },
    CATEGORY_LIST: { name: 'Category', path: '/category-list' },
    DELETE_CATEGORY: { name: 'Delete Category', path: '/delete-category' },

    SUB_CATEGORY_LIST: { name: 'Sub Category', path: '/sub-category-list' },
    ADD_SUB_CATEGORY: { name: 'Add Sub Category', path: '/add-sub-category' },
    UPDATE_SUB_CATEGORY: { name: 'Edit Sub Category', path: '/edit-sub-category' },
    DELETE_SUB_CATEGORY: { name: 'Delete Sub Category', path: '/delete-sub-category' },

    COUNTRY_LIST: { name: 'Country', path: '/country-list' },
    ADD_COUNTRY: { name: 'Add Country', path: '/create-country' },
    UPDATE_COUNTRY: { name: 'Edit Country', path: '/edit-country' },
    DELETE_COUNTRY: { name: 'Delete Country', path: '/delete-country' },

    STATE_LIST: { name: 'State', path: '/state-list' },
    ADD_STATE: { name: 'Add State', path: '/create-state' },
    UPDATE_STATE: { name: 'Edit State', path: '/edit-state' },
    DELETE_STATE: { name: 'Delete State', path: '/delete-state' },

    CITY_LIST: { name: 'City', path: '/city-list' },
    ADD_CITY: { name: 'Add City', path: '/create-city' },
    UPDATE_CITY: { name: 'Edit City', path: '/edit-city' },
    DELETE_CITY: { name: 'Delete City', path: '/delete-city' },

    ADD_VENDOR: { name: 'Add Vendor', path: '/add-vendor' },
    UPDATE_VENDOR: { name: 'Edit Vendor', path: '/edit-vendor' },
    VENDOR_LIST: { name: 'Vendor', path: '/vendor-list' },
    DELETE_VENDOR: { name: 'Delete Vendor', path: '/delete-vendor' },

    ADD_ITEM: { name: 'Add Item', path: '/add-item' },
    UPDATE_ITEM: { name: 'Edit Item', path: '/edit-item' },
    ITEM_LIST: { name: 'Item', path: '/item-list' },
    DELETE_ITEM: { name: 'Delete Item', path: '/delete-item' },
    ITEM_DETAILS: { name: 'Item Detail', path: '/item-details' },

    SPARE_PARTS_LIST: { name: 'Parts', path: '/parts-list' },
    ADD_SPARE_PARTS: { name: 'Add Parts', path: '/add-parts' },
    UPDATE_SPARE_PARTS: { name: 'Edit Parts', path: '/edit-parts' },
    DELETE_SPARE_PARTS: { name: 'Delete Parts', path: '/delete-parts' },

    TOOLS_LIST: { name: 'Tools', path: '/tools-list' },
    ADD_TOOLS: { name: 'Add Tools', path: '/add-tools' },
    UPDATE_TOOLS: { name: 'Edit Tools', path: '/edit-tools' },
    DELETE_TOOLS: { name: 'Delete Tools', path: '/delete-tools' },

    STAFF_LIST: { name: 'Staff', path: '/staff-list' },
    ADD_STAFF: { name: 'Add Staff', path: '/add-staff' },
    UPDATE_STAFF: { name: 'Edit Staff', path: '/edit-staff' },
    DELETE_STAFF: { name: 'Delete Staff', path: '/delete-staff' },

    DEPARTMENT_LIST: { name: 'Department', path: '/department-list' },
    ADD_DEPARTMENT: { name: 'Add Department', path: '/add-department' },
    UPDATE_DEPARTMENT: { name: 'Edit Department', path: '/edit-department' },
    DELETE_DEPARTMENT: { name: 'Delete Department', path: '/delete-department' },

    SERVICE_DEPARTMENT_LIST: { name: 'Service Department', path: '/service-department-list' },
    ADD_SERVICE_DEPARTMENT: { name: 'Add Service Department', path: '/add-service-department' },
    UPDATE_SERVICE_DEPARTMENT: { name: 'Edit Service Department', path: '/edit-service-department' },
    DELETE_SERVICE_DEPARTMENT: { name: 'Delete Service Department', path: '/delete-service-department' },

    BLOCK_LIST: { name: 'Block', path: '/block-list' },
    ADD_BLOCK: { name: 'Add Block', path: '/add-block' },
    UPDATE_BLOCK: { name: 'Edit Block', path: '/edit-block' },
    DELETE_BLOCK: { name: 'Delete Block', path: '/delete-block' },

    LOCATION_LIST: { name: 'Location', path: '/location-list' },
    ADD_LOCATION: { name: 'Add Location', path: '/add-location' },
    UPDATE_LOCATION: { name: 'Edit Location', path: '/edit-location' },
    DELETE_LOCATION: { name: 'Delete Location', path: '/delete-location' },

    SUB_LOCATION_LIST: { name: 'Sub Location', path: '/sub-location-list' },
    ADD_SUB_LOCATION: { name: 'Add Sub Location', path: '/add-sub-location' },
    UPDATE_SUB_LOCATION: { name: 'Edit Sub Location', path: '/edit-sub-location' },
    DELETE_SUB_LOCATION: { name: 'Delete Sub Location', path: '/delete-sub-location' },

    SHIFT_LIST: { name: 'Shift', path: '/shift-list' },
    ADD_SHIFT: { name: 'Add Shift', path: '/add-shift' },
    UPDATE_SHIFT: { name: 'Edit Shift', path: '/edit-shift' },
    DELETE_SHIFT: { name: 'Delete Shift', path: '/delete-shift' },

    SLA_AND_PRIORITY_LIST: { name: 'SLA and Priority', path: '/sla-and-priority-list' },
    ADD_SLA_AND_PRIORITY: { name: 'Add SLA and Priority', path: '/add-sla-and-priority' },
    UPDATE_SLA_AND_PRIORITY: { name: 'Edit SLA and Priority', path: '/edit-sla-and-priority' },
    DELETE_SLA_AND_PRIORITY: { name: 'Delete SLA and Priority', path: '/delete-sla-and-priority' },

    TASK_STATUS_LIST: { name: 'Task Status', path: '/task-status-list' },
    ADD_TASK_STATUS: { name: 'Add Task Status', path: '/add-task-status' },
    UPDATE_TASK_STATUS: { name: 'Edit Task Status', path: '/edit-task-status' },
    DELETE_TASK_STATUS: { name: 'Delete Task Status', path: '/delete-task-status' },

    REASON_LIST: { name: 'Reason', path: '/reason-list' },
    ADD_REASON: { name: 'Add Reason', path: '/add-reason' },
    UPDATE_REASON: { name: 'Edit Reason', path: '/edit-reason' },
    DELETE_REASON: { name: 'Delete Reason', path: '/delete-reason' },

    INVENTORY_UNIT_LIST: { name: 'Inventory Unit', path: '/inventory-unit-list' },
    ADD_INVENTORY_UNIT: { name: 'Add Inventory Unit', path: '/add-inventory-unit' },
    UPDATE_INVENTORY_UNIT: { name: 'Edit Inventory Unit', path: '/edit-inventory-unit' },
    DELETE_INVENTORY_UNIT: { name: 'Delete Inventory Unit', path: '/delete-inventory-unit' },

    MASTER_CHECKLIST_LIST: { name: 'Checklist', path: '/checklist-list' },
    ADD_MASTER_CHECKLIST: { name: 'Add Checklist', path: '/add-checklist' },
    UPDATE_MASTER_CHECKLIST: { name: 'Edit Checklist', path: '/edit-checklist' },
    DELETE_MASTER_CHECKLIST: { name: 'Delete Checklist', path: '/delete-checklist' },
}

export default accessMaster;